import { Button, InputGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import css from "./FilterSearchInput.module.scss";

export interface FilterSearchInputProps {
    value: string;
    onChange: (value: string) => void;
}

export const FilterSearchInput: React.FC<FilterSearchInputProps> = ({
    value,
    onChange
}) => (
    <InputGroup
        className={css["search-input"]}
        leftIcon={IconNames.SEARCH}
        placeholder="Type to filter..."
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        rightElement={
            value ? (
                <Button
                    minimal
                    small
                    icon={IconNames.CROSS}
                    onClick={() => onChange("")}
                />
            ) : undefined
        }
    />
);
